export const NUMBER_LOCALE = "nb-NO";

export const getBrowserLocale = (): string =>
  typeof navigator !== "undefined" ? navigator.language : NUMBER_LOCALE;

interface FormatNumberOptions {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export const formatNumber = (
  value: number,
  {
    locale = NUMBER_LOCALE,
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
  }: FormatNumberOptions = {}
): string =>
  value.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

export const formatNok = (value: number, locale: string = NUMBER_LOCALE): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(Math.round(value));

/** Prevents line breaks inside grouped numbers (e.g. 3 189 417). */
export const numberDisplaySx = {
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
} as const;
